<template>
    <div class="son-page">
        <div class="top-change">
            <div class="top-search">
                <DatePicker
                    @on-change="time"
                    type="daterange"
                    placement="bottom"
                    placeholder="点击选择日期"
                    style="width: 240px"
                ></DatePicker>
                <Button @click="searchBtn" style="margin-left: 30px" class="btn"
                    >搜索</Button
                >
            </div>
        </div>
        <div class="content_box">
            <Table
                ref="selection"
                stripe
                :columns="worlkColumns"
                :data="userdata"
            >
                <template slot-scope="{ index }" slot="name">
                    <div>{{ index + 1 }}</div>
                </template>
                <template slot-scope="{ row }" slot="user_number">
                    <div>{{ row.user ? row.user.user_number : ''}}</div>
                </template>
                <template slot-scope="{ row }" slot="user">
                    <div>{{ row.user ? row.user.name : ''}}</div>
                </template>
            </Table>
            <br />
            <Page
                :total="total"
                :current="storePrams.page"
                style="text-align: right"
                show-elevator
                show-total
                @on-change="pageChange"
                :page-size="storePrams.limit"
            />
        </div>
    </div>
</template>

<script>
import { datacomment_list } from "@/api/user";
export default {
    name: "feedback",
    data() {
        return {
            total: 0,
            storePrams: {
                page: 1,
                limit: 10,
                start_time: "",
                end_time: "",
            },
            userdata: [],
            worlkColumns: [
                {
                    title: "#",
                    slot: "name",
                    align: "center",
                },
                {
                    title: "用户编号",
                    slot: "user_number",
                    align: "center",
                },
                {
                    title: "用户名称",
                    slot: "user",
                    align: "center",
                },
                {
                    title: "内容",
                    key: "content",
                    align: "center",
                },
                {
                    title: "开始时间",
                    key: "created_at",
                    align: "center",
                },
            ],
            data_id: "",
        };
    },
    created() {
        // 2094
        // this.data_id = localStorage.getItem("data_id");
        this.getList();
    },
    methods: {
        getList() {
            datacomment_list(this.storePrams).then((res) => {
                this.total = res.data.total;
                this.userdata = res.data.data;
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        time(e) {
            this.storePrams.start_time = e[0];
            this.storePrams.end_time = e[1];
        },
        searchBtn() {
            this.storePrams.page = 1;
            this.getList();
        },
    },
};
</script>

<style scoped>
.son-page {
}
.top-change {
    width: 100%;
    background: white;
    border-radius: 12px;
    padding: 20px 30px;
    box-sizing: border-box;
}
.top-search {
    width: 100%;
    background: white;
    padding: 20px 0;
    border-radius: 10px;
    display: flex;
}
.btn {
    background: #ff761d;
    color: #fff;
    border-color: #ff761d;
}
.content_box {
    margin-top: 30px;
    padding: 20px 30px;
    width: 100%;
    background: #fff;
    border-radius: 12px;
}
</style>
<style>
.ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
.ivu-form-label-left .ivu-form-item-label {
    text-align: right;
}
.ivu-switch-checked {
    border-color: #ff761d;
    background-color: #ff761d;
}
</style>